<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6">
        <h2>{{user.first_name}} {{user.last_name}}</h2>
      </b-col>
      <b-col sm="6">
        <div class="date-picker">
          <date-range-picker @rangeUpdated="rangeUpdated"></date-range-picker>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col xs="12" lg="6">
        <b-card no-body>
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{deviceUsageNum}}</h4>
            <p>Times Device Used</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col xs="12" lg="6">
        <b-card no-body>
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{activeDevicesNum}}</h4>
            <p>Devices Used</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card>
      <b-row>
        <b-col sm="12">
          <h4 id="traffic" class="card-title mb-0">Device Usage</h4>
          <div class="small text-muted">This Month</div>
        </b-col>
      </b-row>
      <line-chart-device-usage chartId="main-chart-01" :deviceUsage="deviceUsage" :labels="dateLabels" class="chart-wrapper" style="height:300px;margin-top:40px;" v-bind:height="300"></line-chart-device-usage>
    </b-card>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Device Usage</strong>
          </div>
          <b-row>
            <b-col md="6" class="my-1">
              <div class="d-flex">
                <div class="pt-1">Per Page:</div>
                <b-form-group class="mb-0 pl-2">
                  <b-form-select :options="pageOptions" v-model="perPageItems" class="mb-1" />
                </b-form-group>
              </div>
            </b-col>
            <b-col md="6" class="my-1">
              <div class="float-right">
                <div class="d-flex">
                  <div class="pt-1">Search:</div>
                  <b-form-group class="mb-0 pl-2">
                    <b-input-group class="mb-1">
                      <b-form-input v-model="filter" placeholder="Type to Search"  />
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-card>
                <!-- Main table element -->
                <b-table show-empty
                         stacked="md"
                         :items="userActivity"
                         :fields="userActivityFields"
                         :current-page="currentPage"
                         :per-page="perPageItems"
                         :filter="filter"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         :sort-direction="sortDirection"
                         @filtered="onFiltered"
                >
                  <template slot="company_name" slot-scope="row">{{row.value}}</template>
                  <template slot="device" slot-scope="row">
                    <router-link :to="'../devices/' + row.value.device_id">
                      {{row.value.device_name}}
                    </router-link>
                  </template>
                  <template slot="location" slot-scope="row">
                    {{row.value.street_address}}
                    {{row.value.city}},
                    {{row.value.province}}
                    {{row.value.postal_code}}

                  </template>
                  <template slot="time" slot-scope="row">{{row.value | momentTime}}</template>
                </b-table>

                <b-row>
                  <b-col md="12" class="my-1">
                    <div class="float-right">
                      <b-pagination :total-rows="totalRows" :per-page="perPageItems" v-model="currentPage" class="my-0" />
                    </div>
                  </b-col>
                </b-row>

              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
      <loading :active.sync="isLoading"
      :is-full-page="true"></loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import DateRangePicker from '../widgets/DateRangePicker'
import getAdmin from './../../mixins/getAdmin'
import getDeviceUsage from '../../mixins/getDeviceUsage'
import LineChartDeviceUsage from '../charts/LineChartDeviceUsage'
import Loading from 'vue-loading-overlay'
import moment from 'moment'
import onFiltered from '../../mixins/onFiltered'
import sortOptions from '../../mixins/sortOptions'

export default {
  name: 'Company',
  mixins: [
    getAdmin,
    getDeviceUsage,
    onFiltered,
    sortOptions
  ],
  components: {
    DateRangePicker,
    LineChartDeviceUsage,
    Loading
  },
  data: function () {
    return {
      activeDevicesNum: 0,
      activeUsersNum: 0,
      admin: {},
      currentPage: 1,
      dateLabels: [],
      devices: [],
      deviceUsage: [],
      deviceUsageNum: 0,
      filter: null,
      pageOptions: [ 5, 10, 15 ],
      perPageItems: 5,
      perPageUsers: 5,
      selected: 'Month',
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      totalRows: 0,
      user: {},
      userActivity: [],
      userActivityFields: [
        { key: 'company_name', label: 'Company name', sortable: true, sortDirection: 'desc' },
        { key: 'device', label: 'Device', sortable: true },
        { key: 'location', label: 'Location', sortable: true },
        { key: 'time', label: 'Time', sortable: true }
      ],
      userUsage: []
    }
  },
  computed: {
    ...mapGetters([
      'isLoading'
    ])
  },
  methods: {
    /**
     * Queries data from the users controller of the backend API and returns user info given the user id.
     * @param {string} selection - Parameter to determine whether to select all or only authenticated items.
     */
    getUser (selection) {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/users/${this.$route.params.id}?selection=${selection}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data

          self.user = {
            first_name: self.admin.level > 1 ? '***' : data.first_name,
            last_name: self.admin.level > 1 ? '***' : data.last_name
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Queries data from the visits controller of the backend API and returns device usage data for the given user.
     * @param {string} selection - Parameter to determine whether to select all or only authenticated items.
     */
    getUserActivity (selection) {
      this.$store.commit('updateIsLoading', true)

      let self = this
      let begin = moment(this.$store.state.startDate).format('YYYY-MM-DD')
      let end = moment(this.$store.state.endDate).format('YYYY-MM-DD')

      axios.get(`${process.env.VUE_APP_API_URL}api/visits/by_user/${this.$route.params.id}?selection=${selection}&begin=${begin}&end=${end}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data
          let newData = []

          for (let i = 0; i < data.length; i++) {
            newData.push({
              time: data[i].time,
              company_name: data[i].company_name,
              device: {
                device_name: data[i].device_name,
                device_id: data[i].device_id
              },
              location: {
                street_address: data[i].street_address,
                postal_code: data[i].postal_code,
                city: data[i].city,
                province: data[i].province
              }
            })
          }

          self.userActivity = newData

          self.$store.commit('updateIsLoading', false)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Updates getDeviceUsage when the 'rangeUpdated' event is emitted from the DateRangePicker component whenever a new date is selected.
     */
    rangeUpdated () {
      this.getDeviceUsage('USER')
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM Do YYYY')
    },
    momentTime: function (date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    }
  },
  async mounted () {
    this.$store.commit('updateIsLoading', true)
    await this.getAdmin()

    if (this.admin.level === 0) {
      this.getUserActivity('all')
      this.getDeviceUsage('USER', 'all')
      this.getUser('all')
    } else {
      this.getUserActivity()
      this.getDeviceUsage('USER')
      this.getUser()
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  @keyframes spinAround {
    0% {
        transform: rotate(0deg)
    }
    to {
        transform: rotate(359deg)
    }
}

.loading-overlay {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    -ms-flex-align: center;
    align-items: center;
    display: none;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;
    z-index: 999
}

.loading-overlay.is-active {
    display: -ms-flexbox;
    display: flex
}

.loading-overlay.is-full-page {
    position: fixed
}

.loading-overlay.is-full-page .loading-icon:after {
    top: calc(50% - 2.5em);
    left: calc(50% - 2.5em);
    width: 5em;
    height: 5em
}

.loading-overlay .loading-background {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background: #fff;
    opacity: .5
}

.loading-overlay .loading-icon {
  position: relative
}

.loading-overlay .loading-icon:after {
    animation: spinAround .5s infinite linear;
    border: 2px solid #777;
    border-radius: 290486px;
    border-right-color: transparent;
    border-top-color: transparent;
    content: "";
    display: block;
    height: 5em;
    position: relative;
    width: 5em;
    position: absolute;
    top: calc(50% - 1.5em);
    left: calc(50% - 1.5em);
    width: 3em;
    height: 3em;
    border-width: .25em
}
</style>
